module.exports = __webpack_public_path__ + "media/src/images/balloons/orange_gradient-ed051b574f3a74450009da3172f97db6.jpg";